import { makeAutoObservable } from 'mobx';
import { validateEmaIntersectsFirstCandle } from './validateEmaIntersectsFirstCandle';

export class EmaIntersectsFirstCandleData {
  firstCandleCandleDuration = 15;
  emaCandleDuration = 1;
  periodLengths = [];
  associatePerEmaSetup = false;
  candleBarrier = 'HIGH';
  direction = 'ABOVE';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  // common methods
  resetToDefaults = () => {
    this.firstCandleCandleDuration = 15;
    this.emaCandleDuration = 1;
    this.periodLengths = [];
    this.associatePerEmaSetup = false;
    this.candleBarrier = 'HIGH';
    this.direction = 'ABOVE';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = (tradePlan) => {
    const data = {
      firstCandleCandleDuration: this.firstCandleCandleDuration,
      emaCandleDuration: this.emaCandleDuration,
      periodLengths: this.periodLengths,
      candleBarrier: this.candleBarrier,
      direction: this.direction,
      tradePlan,
    };
    const result = validateEmaIntersectsFirstCandle(data);
    return result;
  };
  returnJson = () => {
    return {
      firstCandleCandleDuration: this.firstCandleCandleDuration,
      emaCandleDuration: this.emaCandleDuration,
      periodLengths: this.periodLengths,
      associatePerEmaSetup: this.associatePerEmaSetup,
      candleBarrier: this.candleBarrier,
      direction: this.direction,
    };
  };

  //specific methods
  setFirstFirstCandleDuration = (number) => {
    this.firstCandleCandleDuration = number;
  };
  setEmaCandleDuration = (number) => {
    this.emaCandleDuration = number;
  };
  addPeriodLength = (period) => {
    this.periodLengths.push(period);
  };
  removePeriodLength = (index) => {
    const newArr = this.periodLengths.filter((_, i) => i !== index);
    this.periodLengths = newArr;
  };
  clearPeriodLengths = () => {
    this.periodLengths = [];
  };
}
